import type React from "react";
import { CustomRadio } from "~/components/ui/radioBox";
import styles from "../../index.module.scss";
import type { RadioFieldComponentProps } from "../../types";

const LinkOptions: React.FC<RadioFieldComponentProps> = ({
  options,
  handleRadioOptionChange,
  isReadOnly,
}) => {
  // 入力値の種類
  const protocolOptions = [
    { value: "WEB", label: "Webサイトのアドレス" },
    { value: "CALL", label: "電話番号" },
    { value: "MAIL", label: "メールアドレス" },
  ];

  return (
    <div className={styles["form-group"]}>
      <label>入力値の種類</label>
      <div className={styles["protocolGroup"]}>
        {protocolOptions.map((option) => (
          <CustomRadio
            key={option.value}
            name="protocol"
            label={option.label}
            value={option.value}
            checked={options.protocol === option.value}
            onChange={(value: string) => handleRadioOptionChange("protocol", value)}
            disabled={isReadOnly || false}
          />
        ))}
      </div>
    </div>
  );
};

export default LinkOptions;
